// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export { AjaxMonitor as AjaxPlugin, DfltAjaxCorrelationHeaderExDomains } from "./ajax";
export { DistributedTracingModes } from "@microsoft/applicationinsights-core-js";
//# sourceMappingURL=applicationinsights-dependencies-js.js.map